import { render, staticRenderFns } from "./CreditorsReport.vue?vue&type=template&id=9c50f300&"
import script from "./CreditorsReport.vue?vue&type=script&lang=js&"
export * from "./CreditorsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports